//node modules
import root from 'bunsen/helpers/windowCheck';

export function goToDealerApplication() {
    root.location.href = '/dealer/application-form';
};

export function onTradeApplicationPage() {
    const path = root.location.pathname;
    return path.split('/trade/apply').length > 1;
};



// WEBPACK FOOTER //
// ./assets/js/postAuth/navigation.es.js